import { p as proxyCustomElement, H, h, c as Host } from './p-DUAwwEEc.js';

/*!
 * Planning Center Tapestry Web Components
 * Version: 1.4.1
 */

const SidenavResponsiveHeader = /*@__PURE__*/ proxyCustomElement(class SidenavResponsiveHeader extends H {
    constructor() {
        super();
        this.__registerHost();
        /** Whether the sidenav is open */
        this.isOpen = false;
    }
    // --------------------------------------------------------------------------
    //
    //  Lifecycle
    //
    // --------------------------------------------------------------------------
    componentWillLoad() {
        var _a;
        const parentNavId = (_a = this.el.closest("nav")) === null || _a === void 0 ? void 0 : _a.id;
        if (!parentNavId) {
            throw new Error("Sidenav header must be a child of a nav element");
        }
        this.popoverId = `${parentNavId}-popover`;
    }
    componentDidLoad() {
        const popoverElement = document.getElementById(this.popoverId);
        popoverElement === null || popoverElement === void 0 ? void 0 : popoverElement.addEventListener("toggle", (event) => {
            this.isOpen = event.newState === "open";
        });
    }
    // --------------------------------------------------------------------------
    //
    //  Render Methods
    //
    // --------------------------------------------------------------------------
    render() {
        return (h(Host, { key: 'ff4b52516d2b95805234226032293c3337368708', class: "tds-sidenav-responsive-header" }, this.label && (h("h2", { key: 'c79d79d72f5068b8d6ece3491137ac13eb2fe721', class: "tds-sidenav-responsive-header-label" }, this.label)), h("button", { key: '08497d868603ff8eefeb037af8b0fc0390837af6', type: "button", class: "tds-sidenav-responsive-header-toggle", "aria-label": this.isOpen ? "Close menu" : "Open menu", "aria-controls": this.popoverId, popoverTarget: this.popoverId }, h("svg", { key: '7ac2ae43035fda5dd173417508a900f675b65475', xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16", fill: "none" }, h("path", { key: '0003068346a15970ee7583cbf9c247f9020e0356', d: "M0 6.91104H16V8.68904H0V6.91104ZM0 13.133H16V11.356H0V13.133ZM0 2.46704V4.24404H16V2.46704H0Z", fill: "currentColor" })))));
    }
    get el() { return this; }
}, [2, "tds-sidenav-responsive-header", {
        "label": [1],
        "isOpen": [32]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["tds-sidenav-responsive-header"];
    components.forEach(tagName => { switch (tagName) {
        case "tds-sidenav-responsive-header":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, SidenavResponsiveHeader);
            }
            break;
    } });
}

export { SidenavResponsiveHeader as S, defineCustomElement as d };
//# sourceMappingURL=p-B6mCWWEr.js.map
